export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12104.323cbb24.jpg";